import clsx from "clsx";
import { config } from "common/config";
import { memo } from "react";
import { formatTokenAmount } from "features/wallet/utils";
import Balance from "ui/wallet/components/display/Balance/Balance";
import { BalanceProps } from "ui/wallet/components/display/Balance/Balance.types";

export interface PointsBalanceProps extends Omit<BalanceProps, "units" | "balance"> {
    balance?: string;
}

function PointsBalance({ className, balance = "0", ...rest }: PointsBalanceProps) {
    //TODO: Get the units from API and set the thresholds
    const formattedBalance = formatTokenAmount(balance, config.organization.decimals);
    return (
        <Balance className={clsx("points-balance", className)} balance={formattedBalance} units={config.organization.pointUnit} {...rest} />
    );
}

export default memo(PointsBalance);
